import React from "react"
import { Grid, Skeleton } from "@mui/material"

import { AppCrudTable } from "@components"
import { acrissGroupData, isLoadingAcrissGroupData } from "Pages/OneWay/AcrissGroups/@signals"
import { acrissColumn, actionsColumn, nameColumn } from "./columns"


export default function AcrissGroupsTable() {
	if (isLoadingAcrissGroupData.value) return <Grid item xs={12}><Skeleton variant="rectangular" height={300} /></Grid>

	if (!acrissGroupData.value?.length) return null

	return <Grid item xs={12}>
		<AppCrudTable
			title="Your Acriss Groups"
			data={acrissGroupData.value}
			columns={[
				nameColumn(),
				acrissColumn(),
				actionsColumn(),
			]}
		/>
	</Grid>
}
